// extracted by mini-css-extract-plugin
export var content = "adaptativeSection-module--content--fa9a4";
export var contents = "adaptativeSection-module--contents--fea9f";
export var image = "adaptativeSection-module--image--12969";
export var overlay = "adaptativeSection-module--overlay--9e9fb";
export var wrapper = "adaptativeSection-module--wrapper--52163";